<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Business Centers
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>

          <div class="setting-component">
            <!-- [ Menu ] end -->
            <div class="wrap">
              <div class="wrap__tree">
                <el-row style="margin-bottom: 20px">
                  <el-col :span="24">
                    <div class="nav-tree">
                      <el-button v-if="companyLayout" :disabled="!companyLayout.permission.createBusinessCenters" @click="openModalAdd" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('settings_businessCenters_add')}} {{btnText}}</el-button>
                    </div>
                    <el-table
                        :data="tableData"
                        style="width: 100%"
                        height="400"
                        highlight-current-row
                        :empty-text="$t('general_noData')"
                        @current-change="handleCurrentChange">
                      <el-table-column
                          label="ID"
                          type="index"
                          width="50">
                      </el-table-column>
                      <el-table-column
                          prop="code"
                          :label="$t('settings_businessCenters_code')"
                          width="100">
                      </el-table-column>
                      <el-table-column
                          prop="name"
                          :label="$t('settings_businessCenters_name')">
                      </el-table-column>
                      <el-table-column
                          prop="userName"
                          :label="$t('settings_businessCenters_head')"
                          width="250">
                      </el-table-column>
                      <el-table-column
                          prop="startedDate"
                          :label="$t('settings_businessCenters_startedOn')"
                          width="150">
                      </el-table-column>
                      <el-table-column
                          width="120"
                          :label="$t('settings_businessCenters_operations')">
                        <template slot-scope="scope">
                          <el-button
                              size="mini"
                              type="primary"
                              plain
                              icon="el-icon-edit"
                              v-if="companyLayout"
                              :disabled="!companyLayout.permission.updateBusinessCenters"
                              @click="handleEdit(scope.$index, scope.row)"></el-button>
                          <el-button
                              v-if="!scope.row.isService && companyLayout"
                              size="mini"
                              type="danger"
                              plain
                              icon="el-icon-delete"
                              :disabled="!companyLayout.permission.deleteBusinessCenters"
                              @click="handleDelete(scope.$index, scope.row)"></el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="24">
                    <el-tabs activeName="info" disabled>
                      <el-tab-pane :label="$t('settings_businessCenters_info')" name="info">
                        <div class="user-info" v-if="showInfo">
                          <div class="user-info__details">
                            <ul>
                              <li><div :class="{isEmpty: !info.name}" class="user-info__details_label">{{$t('settings_businessCenters_name')}}:</div> <span class="user-info__details_all" v-html="info.name"></span></li>
                              <li><div :class="{isEmpty: !info.code}" class="user-info__details_label">{{$t('settings_businessCenters_code')}}:</div> <span class="user-info__details_all" v-html="info.code"></span></li>
                              <!--                                    <li><div :class="{isEmpty: !info.description}" class="user-info__details_label">{{$t('settings_businessCenters_description')}}:</div> <span class="user-info__details_all" v-html="info.description"></span></li>-->
                              <li><div :class="{isEmpty: !info.startedOn}" class="user-info__details_label">{{$t('settings_businessCenters_startedOn')}}:</div> <span class="user-info__details_all" v-html="info.startedOn"></span></li>

                              <li><div :class="{isEmpty: !info.country}" class="user-info__details_label">{{$t('settings_businessCenters_country')}}:</div> <span class="user-info__details_all" v-html="info.country"></span></li>
                              <li><div :class="{isEmpty: !info.state}" class="user-info__details_label">{{$t('settings_businessCenters_state')}}:</div> <span class="user-info__details_all" v-html="info.state"></span></li>
                              <li><div :class="{isEmpty: !info.city}" class="user-info__details_label">{{$t('settings_businessCenters_city')}}:</div> <span class="user-info__details_all" v-html="info.city"></span></li>

                              <li><div :class="{isEmpty: !info.streetAddress1}" class="user-info__details_label">{{$t('settings_businessCenters_streetAdress1')}}:</div> <span class="user-info__details_all" v-html="info.streetAddress1"></span></li>
                              <li><div :class="{isEmpty: !info.streetAddress2}" class="user-info__details_label">{{$t('settings_businessCenters_streetAdress2')}}:</div> <span class="user-info__details_all" v-html="info.streetAddress2"></span></li>
                              <li><div :class="{isEmpty: !info.streetAddress3}" class="user-info__details_label">{{$t('settings_businessCenters_streetAdress3')}}:</div> <span class="user-info__details_all" v-html="info.streetAddress3"></span></li>
                              <li><div :class="{isEmpty: !info.businessCenterHead}" class="user-info__details_label">{{$t('settings_businessCenters_businessCenterHead')}}:</div> <span class="user-info__details_all" v-html="info.businessCenterHead"></span></li>
                            </ul>
                          </div>
                        </div>
                      </el-tab-pane>
                      <el-tab-pane :label="$t('settings_businessCenters_about')" name="about">
                        <div v-if="info" v-html="!info.description ? emtyDescription : info.description"></div>
                      </el-tab-pane>
                    </el-tabs>
                  </el-col>
                </el-row>

              </div>
            </div>

            <!-- add -->
            <sweet-modal blocking :title="`${$t('settings_businessCenters_add')} ${btnText}`" ref="openModal" class="modal" v-on:close="closeModal">
              <!-- <h1>Add {{btnText}}</h1> -->
              <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="name">
                      <el-input :label="$t('settings_businessCenters_businessCentersName')" v-model="form.name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="code">
                      <el-input :label="$t('settings_businessCenters_code')" v-model="form.code"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <!-- <el-form-item prop="description">
                  <vue-editor
                    useCustomImageHandler
                    @image-added="handleImageAdded"
                    v-model="form.description"></vue-editor>
                </el-form-item> -->

                <el-form-item>
                  <el-button v-on:click="$refs.nestedChildAdd.open()" style="width: 100%;">About this Business Centers</el-button>
                </el-form-item>

                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="date">
                      <el-date-picker
                          style="width: 100%;"
                          format="d MMM yy"
                          v-model="form.date"
                          type="date"
                          :placeholder="$t('settings_businessCenters_pickADate')"
                          value-format="timestamp">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="countryId">
                      <el-select v-model="form.countryId" :placeholder="$t('settings_businessCenters_country')" filterable style="width: 100%;">
                        <el-option
                            v-for="country in form.countries"
                            :key="country.id"
                            :label="country.name"
                            :value="country.id"
                            @click.native="setState(country.id)"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="stateId">
                      <el-select v-model="form.stateId" :placeholder="$t('settings_businessCenters_state')" filterable style="width: 100%;">
                        <el-option
                            v-for="item in form.state"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            @click.native="setCity(item.id)"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="cityId">
                      <el-select v-model="form.cityId" :placeholder="$t('settings_businessCenters_city')" filterable style="width: 100%;">
                        <el-option
                            v-for="item in form.city"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item prop="street1">
                  <el-input :label="$t('settings_businessCenters_streetAdress1')" v-model="form.street1"></el-input>
                </el-form-item>
                <el-form-item prop="street2">
                  <el-input :label="$t('settings_businessCenters_streetAdress2')" v-model="form.street2"></el-input>
                </el-form-item>
                <el-form-item prop="street3">
                  <el-input :label="$t('settings_businessCenters_streetAdress3')" v-model="form.street3"></el-input>
                </el-form-item>
                <el-form-item prop="headId">
                  <el-select v-model="form.headId" :placeholder="$t('settings_businessCenters_businessCenterHead')" style="width: 100%;">
                    <el-option
                        v-for="item in form.head"
                        :key="item.user.id"
                        :label="item.user.fullName"
                        :value="item.user.id"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item class="modal__btn">
                  <el-button @click="modalCancel('openModal')">{{$t('general_cancel')}}</el-button>
                  <el-button @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
              </el-form>
            </sweet-modal>

            <!-- edit -->
            <sweet-modal blocking :title="`${$t('settings_businessCenters_edit')} ${btnText}`" ref="openModalEdit" class="modal" v-on:close="closeModalEdit">
              <!-- <h1>Edit {{btnText}}</h1> -->
              <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">

                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="name">
                      <el-input :label="$t('settings_businessCenters_businessCentersName')" v-model="formEdit.name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="code">
                      <el-input :label="$t('settings_businessCenters_code')" v-model="formEdit.code"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <!-- <el-form-item prop="description">
                  <vue-editor
                    useCustomImageHandler
                    @image-added="handleImageAdded"
                    v-model="formEdit.description"></vue-editor>
                </el-form-item> -->

                <el-form-item>
                  <el-button v-on:click="$refs.nestedChildEdit.open()" style="width: 100%;">About this Business Centers</el-button>
                </el-form-item>

                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="date">
                      <el-date-picker
                          style="width: 100%;"
                          format="d MMM yy"
                          v-model="formEdit.date"
                          type="date"
                          :placeholder="$t('settings_businessCenters_pickADate')"
                          value-format="timestamp">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="countryId">
                      <el-select v-model="formEdit.countryId" :placeholder="$t('settings_businessCenters_country')" filterable style="width: 100%;">
                        <el-option
                            v-for="country in formEdit.countries"
                            :key="country.id"
                            :label="country.name"
                            :value="country.id"
                            @click.native="setStateEdit(country.id)"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="stateId">
                      <el-select v-model="formEdit.stateId" :placeholder="$t('settings_businessCenters_state')" filterable style="width: 100%;">
                        <el-option
                            v-for="item in formEdit.state"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            @click.native="setCityEdit(item.id)"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="cityId">
                      <el-select v-model="formEdit.cityId" :placeholder="$t('settings_businessCenters_city')" filterable style="width: 100%;">
                        <el-option
                            v-for="item in formEdit.city"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item prop="street1">
                  <el-input :label="$t('settings_businessCenters_streetAdress1')" v-model="formEdit.street1"></el-input>
                </el-form-item>
                <el-form-item prop="street2">
                  <el-input :label="$t('settings_businessCenters_streetAdress2')" v-model="formEdit.street2"></el-input>
                </el-form-item>
                <el-form-item prop="street3">
                  <el-input :label="$t('settings_businessCenters_streetAdress3')" v-model="formEdit.street3"></el-input>
                </el-form-item>
                <el-form-item prop="headId">
                  <el-select v-model="formEdit.headId" :placeholder="$t('settings_businessCenters_businessCenterHead')" style="width: 100%;">
                    <el-option
                        v-for="item in formEdit.head"
                        :key="item.user.id"
                        :label="item.user.fullName"
                        :value="item.user.id"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item class="modal__btn">
                  <el-button @click="modalCancel('openModalEdit')">{{$t('general_cancel')}}</el-button>
                  <el-button @click="editItem('formEdit')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
              </el-form>
            </sweet-modal>

            <!-- add description -->
            <sweet-modal blocking ref="nestedChildAdd">
              <vue-editor
                useCustomImageHandler
                @image-added="handleImageAdded"
                v-model="form.description"></vue-editor>
              <el-button slot="button" v-on:click="$refs.nestedChildAdd.close()" type="primary">{{$t('modal_businessUnits_submit')}}</el-button>
            </sweet-modal>

            <!-- edit description -->
            <sweet-modal blocking ref="nestedChildEdit">
              <vue-editor
                useCustomImageHandler
                @image-added="handleImageAdded"
                v-model="formEdit.description"></vue-editor>
              <el-button slot="button" v-on:click="$refs.nestedChildEdit.close()" type="primary">{{$t('modal_businessUnits_submit')}}</el-button>
            </sweet-modal>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let moment = require('moment')
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import { VueEditor } from 'vue2-editor'

export default {
  name: 'BusinessCenters',
  components: {
    SweetModal,
    VueEditor,
  },
  beforeCreate() {},
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    },
  },
  data() {
    return {
      showInfo: false,
      currentRow: null,
      paleceholderText: this.$i18n.t('settings_businessCenters'),
      btnText: this.$i18n.t('settings_businessCenters'),
      tableData: [],
      selectedRowId: '',
      moment:moment,
      serviceIndex: null,
      form:{
        name: '',
        code: '',
        description: '',
        date: '',
        countries: [],
        countryId: '',
        state: [],
        stateId: null,
        city:[],
        cityId: null,
        street1: '',
        street2: '',
        street3: '',
        head: [],
        headId: ''
      },
      formEdit:{
        name: '',
        code: '',
        description: '',
        date: '',
        countries: [],
        countryId: '',
        state: [],
        stateId: null,
        city:[],
        cityId: null,
        street1: '',
        street2: '',
        street3: '',
        head: [],
        headId: ''
      },
      rules: {
        name: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        description: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        date: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        countryId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        stateId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        cityId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        headId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ]
      },
      rulesEdit: {
        name: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        description: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        date: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        countryId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        stateId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        cityId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ],
        headId: [
          { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
        ]
      },
      info: {
        name: null,
        code: null,
        description: null,
        startedOn: null,
        country: null,
        state: null,
        city: null,
        streetAddress1: null,
        streetAddress2: null,
        streetAddress3: null,
        businessCenterHead: null,
      },
      emtyDescription: this.$i18n.t('noDetailsProvided')
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      let loader = this.$loading.show();
      console.log("FILE",file);
      // this.form.imageUrl = URL.createObjectURL(file.raw);
      // console.log('---', this.form.imageUrl);
      var formData = new FormData();
      formData.append('file', file);

      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/files/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
        .then(response => {
          let url = response.data.fileUrl // Get url from response
          Editor.insertEmbed(cursorLocation, 'image', url);
          resetUploader();
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        })
    },
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    setState(id) {
      this.form.stateId = null
      this.form.cityId = null
      this.form.city = []

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/businessCenters/directories?companyId=${this.$route.query.companyId}&operation=getStateList&countryId=${id}`)
          .then(response => {
            loader.hide()
            this.form.state = response.data.stateList
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
    },
    setCity(id) {
      this.form.cityId = null

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/businessCenters/directories?companyId=${this.$route.query.companyId}&operation=getCityList&stateId=${id}`)
          .then(response => {
            loader.hide();
            this.form.city = response.data.cityList
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
          });
    },
    setStateEdit(id) {
      this.formEdit.stateId = null
      this.formEdit.cityId = null
      this.formEdit.city = []

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/businessCenters/directories?companyId=${this.$route.query.companyId}&operation=getStateList&countryId=${id}`)
          .then(response => {
            loader.hide()
            this.formEdit.state = response.data.stateList
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
    },
    setCityEdit(id) {
      this.formEdit.cityId = null

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/businessCenters/directories?companyId=${this.$route.query.companyId}&operation=getCityList&stateId=${id}`)
          .then(response => {
            loader.hide()
            this.formEdit.city = response.data.cityList
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
    },
    handleCurrentChange(val) {
      if (!val) return;
      this.currentRow = val;
      console.log('---handleCurrentChange', val);

      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/businessCenters/info?companyId=${this.$route.query.companyId}&businessCenterId=${val.id}`)
          .then(response => {
            console.log('---/businessCenters/info', response.data);
            this.info.name = response.data.info.name;
            this.info.code = response.data.info.code;
            this.info.description = response.data.info.description;

            // let date = response.data.info.startedDate.toString();
            // if (date.length < 8) { date = '0' + date }
            // date = moment(date, 'DDMMYYYY').format('DD MMMM YYYY');
            // this.info.startedOn = date;
            this.info.startedOn = moment(response.data.info.startedDate, 'X').format('D MMM YY');

            this.info.country = response.data.info.countryName;
            this.info.state = response.data.info.stateName;
            this.info.city = response.data.info.cityName;

            this.info.streetAddress1 = response.data.info.addressLine1;
            this.info.streetAddress2 = response.data.info.addressLine2;
            this.info.streetAddress3 = response.data.info.addressLine3;
            this.info.businessCenterHead = response.data.info.userFullName
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });

      this.showInfo = true
    },
    loadList(){
      this.showInfo = false;
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/businessCenters/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            let list = response.data.list
            for (let i = 0; i < list.length; i++) {
              if (i == 0 || i == 1) {
                list[i].isService = 1
              } else {
                list[i].isService = 0
              }
              list[i].startedDate = moment(list[i].startedDate, 'X').format('D MMM YY');
            }
            this.tableData = response.data.list
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
    },
    addItem(form){
      this.$refs[form].validate((valid) => {
        if (valid) {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/businessCenters/create?companyId=${this.$route.query.companyId}`, {
                // companyId: this.$route.query.companyId,
                // name: this.form.name,
                // code: this.form.code,

                name: this.form.name,
                description: this.form.description,
                code: this.form.code,
                countryId: this.form.countryId,
                stateId: this.form.stateId,
                cityId: this.form.cityId,
                startedDate: this.form.date / 1000,
                addressLine1: this.form.street1,
                addressLine2: this.form.street2,
                addressLine3: this.form.street3,
                headUserId: this.form.headId
              })
              .then(response => {
                this.$refs.openModal.close()
                this.loadList()
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
        }else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    openModalAdd(){
      // this.$refs.openModal.open()

      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/businessCenters/directories?companyId=${this.$route.query.companyId}&operation=create`)
          .then(response => {
            if (response.data.success){
              console.log("success");
              this.form.countries = response.data.countryList;
              this.form.head = response.data.companyUserList;
              this.form.city = response.data.cityList;
              this.form.state = response.data.stateList;
              this.$refs.openModal.open()
            }
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
    },
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
    closeModal(){
      // this.form.name = null
      // this.form.code = null
      // this.form.description = null
      // this.form.date = null
      // this.form.countries = this.formGet.countries
      // this.form.countryId = null
      // this.form.city = []
      // this.form.cityId = null
      // this.form.state = []
      // this.form.stateId = null
      // this.form.street1 = null
      // this.form.street2 = null
      // this.form.street3 = null
      // this.form.head = null
      // this.form.headId = null
      this.$refs['form'].resetFields();
    },
    closeModalEdit(){
      // this.formEdit.name = null
      // this.formEdit.code = null
      // this.formEdit.description = null
      // this.formEdit.date = null
      // this.formEdit.countries = this.formGet.countries
      // this.formEdit.countryId = null
      // this.formEdit.city = []
      // this.formEdit.cityId = null
      // this.formEdit.state = []
      // this.formEdit.stateId = null
      // this.formEdit.street1 = null
      // this.formEdit.street2 = null
      // this.formEdit.street3 = null
      // this.formEdit.head = null
      // this.formEdit.headId = null
      this.$refs['formEdit'].resetFields();
    },
    handleEdit(index, row) {
      console.log(row)
      this.selectedRowId = row.id

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.post(`/api/v1/businessCenters/directories?companyId=${this.$route.query.companyId}&operation=update`)
          .then(response => {
            loader.hide()
            console.log('---', response.data);
            if (response.data.success){
              console.log("success");
              this.formEdit.countries = response.data.countryList
              this.formEdit.head = response.data.companyUserList
              // this.formEdit.city = response.data.cityList
              // this.formEdit.state = response.data.stateList

              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                  .post(`/api/v1/businessCenters/item?companyId=${this.$route.query.companyId}&businessCenterId=${row.id}`)
                  .then(response => {
                    // this.formEdit.name = response.data.item.name
                    // this.formEdit.code = response.data.item.code
                    if (response.data.item.countryId) this.setStateEdit(response.data.item.countryId);
                    if (response.data.item.stateId) this.setCityEdit(response.data.item.stateId);
                    this.formEdit.date = moment(response.data.item.startedDate.toString(), 'X').format('x')
                    this.formEdit.name = response.data.item.name;
                    this.formEdit.code = response.data.item.code;
                    this.formEdit.description = response.data.item.description;
                    this.formEdit.stateId = response.data.item.stateId;
                    this.formEdit.cityId = response.data.item.cityId;
                    this.formEdit.countryId = response.data.item.countryId;
                    this.formEdit.street1 = response.data.item.addressLine1;
                    this.formEdit.street2 = response.data.item.addressLine2;
                    this.formEdit.street3 = response.data.item.addressLine3;
                    this.formEdit.headId = response.data.item.headUserId;

                    this.$refs.openModalEdit.open()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                  });
            }
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
    },
    editItem(formEdit){
      this.$refs[formEdit].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/businessCenters/update?companyId=${this.$route.query.companyId}&businessCenterId=${this.selectedRowId}`, {
                name: this.formEdit.name,
                description: this.formEdit.description,
                code: this.formEdit.code,
                countryId: this.formEdit.countryId,
                stateId: this.formEdit.stateId,
                cityId: this.formEdit.cityId,
                startedDate: this.formEdit.date / 1000,
                addressLine1: this.formEdit.street1,
                addressLine2: this.formEdit.street2,
                addressLine3: this.formEdit.street3,
                headUserId: this.formEdit.headId
              })
              .then(response => {
                this.$refs.openModalEdit.close()
                this.loadList()
                loader.hide()
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
        }else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleDelete(index, row) {
      this.selectedRowId = row.id

      this.$confirm(this.$t('settings_businessCenters_ThisWillPermanentlyDeleteTheTemplatesContinue'), 'Warning', {
        confirmButtonText: this.$t('general_ok'),
        cancelButtonText: this.$t('general_cancel'),
        type: 'info'
      }).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('general_deleteCompleted')
        });

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/businessCenters/delete?companyId=${this.$route.query.companyId}&businessCenterId=${this.selectedRowId}`)
            .then(response => {
              this.loadList()
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('general_deleteCanceled')
        });
      });
    },
    showMenu() {
      this.open = true
      console.log('---', this.open);
    },
    hideMenu() {
      this.open = false
      console.log('---', this.open);
    },
    companyName(name) {
      this.companyNameSelect = name
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
  },
  // watch:{
  //   tableData(val){
  //     val.forEach(i =>{
  //       i.createDate = moment(i.createDate.toString(), 'X').format('DD MMMM YYYY')
  //     })
  //   }
  // }
}
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}

.setting-component{
  min-width:810px;
}

.isEmpty {
  color: #ccc
}

.modal {
  &__title {
    text-align: center;
  }
  &__btn {
    text-align: right;
  }
}

.user-info {
  &__title {
    margin-top: 0;
  }
  &__content {
    display: flex;
  }
  &__photo {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    margin-right: 20px;
    background: url('~@/assets/img/user-default.jpg');
    background-size: cover;
    img {
      width: 150px;
      height: 150px;
      border-radius: 50%;
      // background: url('~@/assets/img/user-default.jpg');
      background-size: cover;
    }
  }
  &__details {
    .isEmpty {
      color: #ccc
    }
    &_label {
      display: inline-block;
      width: 150px;
    }
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      color: #888;
      li {
        margin-bottom: 8px;
        span {
          font-weight: 500;
        }
      }
    }
    &_email {
      font-weight: bold;
      background: #888;
      color: white;
      border-radius: 5px;
      padding: 3px;
    }
    &_status {
      font-weight: bold;
      background: #5cb85c;
      color: white;
      border-radius: 5px;
      padding: 3px;
    }
    &_all {
      font-weight: bold;
    }
  }
}
</style>
